import React from "react";

function Configuracion() {
  return <div>Coño que configuración no sirve nojoda, le acabo de decir</div>;
}

export default Configuracion;
